<template lang="pug">
  .sticker.fixed.bottom-0.z-50.pointer-events-auto(v-if="site && site.sticker_image", :class="classes", :style="style")
    wp-link.pointer-events-auto.block(:link="site.sticker_link")
      img.block.w-full(:src="cloudinary(site.sticker_image)", :alt="Sticker")
</template>

<script>
import wpLink from '@/components/WPLink'
import { mapState } from 'vuex'
import { cloudinaryThumbSrc as cloudinary } from '@/utils'
export default {
  name: 'Sticker',
  data () {
    return {
      cloudinary
    }
  },
  computed: {
    ...mapState(['site', 'cart']),
    classes () {
      return {
        'right-0': this.site.sticker_position.includes('right'),
        'left-0': this.site.sticker_position.includes('left')
      }
    },
    style () {
      return {
        boxSizing: 'content-box',
        width: this.site.sticker_width + 'vw',
        padding: this.site.sticker_margin + 'vw'
      }
    }
  },
  components: { wpLink }
}
</script>

<style>
</style>
